var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.newVersion
        ? [
            _c(
              "md-field",
              { class: _vm.fieldClass },
              [
                _c("label", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("registration.entity-type")) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "md-select",
                  {
                    attrs: {
                      name: _vm.name,
                      disabled: _vm.disabled,
                      dusk: "country-input"
                    },
                    on: { "md-selected": _vm.selected },
                    model: {
                      value: _vm.entity_type_id,
                      callback: function($$v) {
                        _vm.entity_type_id = $$v
                      },
                      expression: "entity_type_id"
                    }
                  },
                  _vm._l(_vm.entityTypes, function(entityType) {
                    return _c(
                      "md-option",
                      { key: entityType.id, attrs: { value: entityType.id } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(entityType.name) +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "md-error" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.errors && _vm.errors.length ? _vm.errors[0] : ""
                      ) +
                      "\n            "
                  )
                ])
              ],
              1
            )
          ]
        : [
            _c(
              "label",
              {
                staticClass: "block ml-1 mb-1 text-xs font-medium text-gray-900"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("registration.entity-type")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "md-menu",
              {
                staticClass:
                  "entity-type-selector block bg-white border border-gray-200 text-gray-900 text-sm rounded-md focus:ring-blue-900 block w-full p-1.5 placeholder:italic",
                class: {
                  "border-red-500": !!(_vm.errors && _vm.errors.length)
                },
                attrs: { "md-direction": "bottom-start" }
              },
              [
                _c(
                  "md-button",
                  {
                    staticClass:
                      "!py-0 !min-w-8 !px-1 nv-button text-sm font-normal h-auto w-full normal-case !text-primary-dark-50",
                    attrs: { "md-menu-trigger": "" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "flex items-center justify-between w-full",
                        class: {
                          "text-red-500": !!(_vm.errors && _vm.errors.length)
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.currentLabel ||
                                _vm.$t("registration.select-entity-type")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "w-4 h-4 ml-2 text-gray-500",
                            attrs: {
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 9l-7 7-7-7"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "md-menu-content",
                  _vm._l(_vm.entityTypes, function(entityType) {
                    return _c(
                      "md-menu-item",
                      {
                        key: entityType.id,
                        on: {
                          click: function($event) {
                            _vm.choose(entityType)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(entityType.name) +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("span", { staticClass: "md-error" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.errors && _vm.errors.length ? _vm.errors[0] : "") +
                  "\n        "
              )
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2901c933", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2901c933","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/EntityTypeSelector.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2901c933","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/EntityTypeSelector.vue
// module chunks = 1 2 3